import {CommonMessages} from '../common.messages';

export const MarketDataFeedMarkupMessages = {
    ListMarketDataFeedMarkupFailed: {
        key: 'ListMarketDataFeedMarkupFailed',
        message: 'Error while processing request. Unable to list a markup data.'
    },
    MarketDataFeedMarkupDeletionFailed: {
        key: 'MarketDataFeedMarkupDeletionFailed',
        message: 'Error while processing request. Unable to delete a Markup.'
    },
    MarketDataFeedMarkupDeletionSucceed: {
        key: 'MarketDataFeedMarkupDeletionSucceed',
        message: 'Markup is successfully deleted.'
    },
    UpdateMarketDataFeedMarkupFailed: {
        key: 'UpdateMarketDataFeedMarkupFailed',
        message: 'Error while processing request. Unable to update a Markup Subscription.'
    },
    UpdateMarketDataFeedMarkupSuccess: {
        key: 'UpdateMarketDataFeedMarkupSuccess',
        message: 'Markup is successfully updated.'
    },
    UpdateMarketDataFeedMarkupFailedAllRequired: {
        key: 'UpdateMarketDataFeedMarkupFailedAllRequired',
        message: 'All inputs are required for Markup creation.'
    },
    UpdateMarketDataFeedMarkupFailedAskAndBidCanNotBeZero: {
        key: 'UpdateMarketDataFeedMarkupFailedAskAndBidCanNotBeZero',
        message: 'Bid and Ask prices cannot be 0 at the same time!'
    },
    ...CommonMessages
};
